(()=>{
 function init(container){
  container.querySelectorAll('[data-kameo-service]').forEach(root=>{
   if(root.dataset.initialized)return;root.dataset.initialized='true';
   const header=document.querySelector('header[id^="shopify-section"]');
   if(header){const measure=()=>root.style.setProperty('--ks-header-height',header.getBoundingClientRect().height+'px');measure();const observer=new ResizeObserver(()=>{if(!root.isConnected){observer.disconnect();return}measure()});observer.observe(header)}
   root.querySelectorAll('[data-tabs]').forEach(group=>{
    const tabs=[...group.querySelectorAll('[role=tab]')];
    function select(tab,focus=false){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;root.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active});if(focus)tab.focus()}
    tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n],true)}})});
   });
   root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
    const filter=button.dataset.filter;let count=0;
    root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    root.querySelectorAll('tr[data-category]').forEach(row=>{row.hidden=filter!=='all'&&row.dataset.category!==filter;if(!row.hidden)count++});
    root.querySelector('.ks-filter-count').textContent=count+' '+(count===1?'product':'producten');
   }));
  });
 }
 init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();
